import React, { forwardRef, useEffect } from 'react';
import shallow from 'zustand/shallow';

import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import { useStore } from '../zustand';
import { TherapistModule } from './therapistModule';

export const ServicesPricing = forwardRef(
  ({ pricingSubtitle, therapists, pricingTitle }, ref) => {
    const [pricingInView] = useIntersectionObserver(ref, {});

    const [setSubNavigationServices, setServicesInView] = useStore(
      (state) => [state.setSubNavigationServices, state.setServicesInView],
      shallow
    );

    useEffect(() => {
      setSubNavigationServices(3);

      if (pricingInView) {
        setServicesInView({ 3: true });
      } else {
        setServicesInView({ 3: false });
      }
    }, [pricingInView]);

    return (
      <TherapistModule
        ref={ref}
        description={pricingSubtitle}
        therapists={therapists}
        title={pricingTitle}
      />
    );
  }
);
